import React from 'react';
import { SurveyHeader } from './components/SurveyHeader';
import { SurveyFooter } from './components/SurveyFooter';
import { Survey } from './pages/Survey';
export function App() {
  return <div className="min-h-screen w-full bg-gradient-to-br from-[#d4f3ef] via-[#e6f0f9] to-[#f8e1eb] py-12 px-4 sm:px-6 lg:px-8 font-sans" data-id="element-0" data-mp="3k9b5s5c29u3b">
      <div className="max-w-4xl mx-auto flex flex-col min-h-[calc(100vh-6rem)]" data-id="element-1" data-mp="3fb16bijb07bw">
        <SurveyHeader data-id="element-2" data-mp="2rlyrsjjyuulm" />

        <main className="flex-grow" data-id="element-3" data-mp="2rlfb1661yc96">
          <Survey data-id="element-4" data-mp="2mlu5ue0ah7o0" />
        </main>

        <SurveyFooter data-id="element-5" data-mp="2mmvj8p4s268w" />
      </div>
    </div>;
}